import { useEffect } from 'react';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import { CustomIcon } from '~components/index';
import type { ActiveKey } from './Accordion';

interface Props<T> {
  item: T;
  index: number;
  activeKey: ActiveKey;
  openAutomatically?: boolean;
  onEnter?: (item: T) => void;
  setActiveKey: Setter<ActiveKey>;
}

export const AccordionToggle = <T extends object>({
  item,
  index,
  activeKey,
  openAutomatically = false,
  setActiveKey,
  onEnter
}: Props<T>) => { 
  const onClick = useAccordionButton(`${index}`, () => {
    if (activeKey !== `${index}`) {
      setActiveKey(`${index}`);
      onEnter?.(item);
    } else setActiveKey(null);
  });

  useEffect(() => {
    if (openAutomatically) {
      setActiveKey(`${index}`);
      onEnter?.(item);
    }
  }, [openAutomatically, activeKey, index, item, onEnter, setActiveKey]);

  return (
    <div role="accordion_toggle" onClick={onClick}>
      <CustomIcon
        name={`${index}` === activeKey ? 'chevronUp' : 'chevronDown'}
        className="cursor-pointer"
      />
    </div>
  );
};
